module.exports = __webpack_public_path__ + "as.480d167afc7668434f83.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/as.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/as.svg
// module chunks = styles